import React from 'react';
import Reveal from './Reveal';

/**
 * SectionHeader — consistent eyebrow + title + subtitle block.
 */
const SectionHeader = ({ eyebrow, title, subtitle, align = 'center', light = false }) => {
  const isCenter = align === 'center';
  return (
    <Reveal className={`${isCenter ? 'text-center mx-auto' : 'text-left'} max-w-3xl ${isCenter ? '' : 'mr-auto'} mb-12 lg:mb-16`}>
      {eyebrow && (
        <span className={`eyebrow ${isCenter ? 'justify-center' : ''} ${light ? 'text-brand-300' : ''}`}>
          {eyebrow}
        </span>
      )}
      <h2 className={`section-title mt-4 ${light ? 'text-white' : ''}`}>{title}</h2>
      {subtitle && (
        <p className={`section-sub mt-4 ${light ? 'text-navy-100/80' : ''}`}>{subtitle}</p>
      )}
    </Reveal>
  );
};

export default SectionHeader;
